
























import FileGroupList from '@/components/file/FileGroupList.vue'
import { Component, Vue } from 'vue-property-decorator'
import UploadModal from '@/components/UploadModal.vue'
import { mapGetters } from 'vuex'

@Component({
  name: 'file-page',
  components: { FileGroupList },
  computed: mapGetters({
    hasAdminRole: 'auth/hasAdminRole',
    hasSuperAdminRole: 'auth/hasSuperAdminRole'
  })
})
export default class FilePage extends Vue {
  hasAdminRole: boolean
  hasSuperAdminRole: boolean
  fileType = this.$store.getters['auth/hasAdminRole'] || this.$store.getters['auth/hasSuperAdminRole'] ? 'FEE' : 'SCORE'

  get fileOptions () {
    return this.hasAdminRole || this.hasSuperAdminRole ? [{
      value: 'FEE',
      text: 'Fee'
    }, {
      value: 'SCORE',
      text: 'Score'
    }] : [{
      value: 'SCORE',
      text: 'Score'
    }]
  }

  newFile () {
    this.$buefy.modal.open({
      parent: this,
      component: UploadModal,
      props: { type: this.fileType },
      hasModalCard: true,
      trapFocus: true,
      canCancel: ['x', 'escape']
    })
  }
}
